import { useEffect, useState } from 'react';

/**
 * Hook to track page visibility using the Page Visibility API
 * @returns The current visibility state (true if visible, false if hidden)
 */
export function usePageVisibility(): boolean {
  const [isVisible, setIsVisible] = useState(
    document.visibilityState === 'visible',
  );

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === 'visible');
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return isVisible;
}
